(() => {
  window.UnobtrusiveFlash.showFlashMessage = (message, options) => {
    const config = { timeout: 0, ...options };

    // Workaround for common Rails flash type to match common Bootstrap alert type
    let alertType = "info";
    if (config.type === "alert") {
      alertType = "warning";
    } else if (config.type === "error") {
      alertType = "danger";
    }

    const $area = $(
      $(".flash-alert-area")[0] || $(".root-flash-alert-area")[0],
    );

    const animate = !$area.data("disable-animate");

    const btn = `
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `;

    const title = `
      <h5 class="alert-heading">${options.title}</h5>
    `;

    let alertMessage = message;

    // We have encoded links in our email confirmation flash message.
    if (alertMessage.includes("confirm your email")) {
      alertMessage = $("<div/>").html(alertMessage).text();
    }

    const $flash = $(`
      <div class="alert flash-alert alert-${alertType} fade show" role="alert">
        <i class="fa icon-${alertType}"></i>
        <div class="alert-content">
          ${options.title ? title : ""}
          ${alertMessage}
        </div>
        ${animate ? btn : ""}
      </div>
    `);

    $area.prepend($flash);

    if (config.onClick) {
      $flash.attr("role", "button");
      $flash.on("click", (evt) => {
        // Make sure it's not the close button
        if (!$(evt.target).parents(".btn-close").length) {
          options.onClick(evt);
        }
      });
    }

    if (animate) {
      $flash.hide().delay(300).slideDown(100).alert();
    } else {
      $flash.alert();
    }

    if (animate && config.timeout > 0) {
      setTimeout(() => {
        $flash.slideUp(100).alert("close");
      }, config.timeout);
    }
  };

  $(window).bind("rails:flash", (e, params) => {
    window.UnobtrusiveFlash.showFlashMessage(params.message, {
      timeout: 4000,
      ...params,
    });
  });
})();
